import { Fragment, useState } from "react";
import { useSelector } from "react-redux";
import { DropDownListById } from "../forms/form-components";
import { Loader } from "@progress/kendo-react-indicators";
import { themes } from "../sass/themes";
import { Checkbox } from "@progress/kendo-react-inputs";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const sideBarTypes = [
  { Id: 1, Title: "Hidden" },
  { Id: 2, Title: "Mini" },
];

export const ThemesSelector = (props) => {
  const { onThemeChange, onIsRightToLeftChange, onSideBarChange, ...other } =
    props;

  const currentTheme = useSelector((state) => state.currentTheme);
  const appearance = useSelector((state) => state.appearance);
  const currentUser = useSelector((state) => state.currentUser);

  const [themeId, setThemeId] = useState(currentTheme.id);
  const [isRightToLeft, setIsRightToLeft] = useState(appearance.isRightToLeft);
  const [sideBarType, setSideBarType] = useState(currentUser.SideBarType);

  const { t } = useTranslation();

  let themesArr = [];
  for (let prop in themes) themesArr.push(themes[prop]);

  return (
    <Fragment>
      {currentTheme.processing && (
        <div className="loader">
          <Loader
            size={"large"}
            type="infinite-spinner"
            themeColor={"primary"}
          />
          {currentTheme.processingText && (
            <div style={{ fontSize: 13, color: currentTheme.primary }}>
              {currentTheme.processingText}
            </div>
          )}
        </div>
      )}
      <div className="theming">
        <div>{t("theme.theme")}</div>
        <DropDownListById
          data={themesArr}
          dataItemKey="id"
          textField="name"
          value={themeId}
          style={{ marginTop: 4 }}
          onChange={(e) => {
            onThemeChange(e);
            setThemeId(e.value);
          }}
        />

        <div style={{ marginTop: 36 }}>{t("theme.sidebar")}</div>
        <DropDownListById
          data={sideBarTypes}
          dataItemKey="Id"
          textField="Title"
          value={sideBarType}
          style={{ marginTop: 4 }}
          onChange={(e) => {
            onSideBarChange(e);
            setSideBarType(e.value);
          }}
        />

        {/* <div style={{ marginTop: 36 }}>
          <Checkbox
            style={{
              marginRight: appearance.isRightToLeft ? 0 : 6,
              marginLeft: appearance.isRightToLeft ? 6 : 0,
            }}
            value={isRightToLeft}
            onChange={(e) => {
              setIsRightToLeft(e.value);
              onIsRightToLeftChange(e.value);
            }}
          >
            {t("theme.rightleft")}
          </Checkbox>
        </div> */}
      </div>
      <style>
        {`
                    /*the loader*/
                    .themes-selector .loader
                    {
                        position: absolute;
                        z-index: 9999;
                        top: calc(50% - 50px); 
                        left: calc(50% - 60px);
                        display: flex;
                        flex-direction: column;
                        justify-content: center;
                        align-items: center;
                        padding: 8px;
                        background-color: ${currentTheme.componentBg};
                        border: 1px solid ${currentTheme.componentBorderColor};
                        border-radius: 6px;
                    }
                    /*the loader*/

                    .themes-selector .k-dialog
                    {
                        width: 400px;
                    }
                    .themes-selector .k-dialog .k-header
                    {
                        background-color: ${currentTheme.dialogToolbarBg} !important;
                    }

                    .themes-selector .theming
                    {
                        padding: 12px 2px 26px 2px;
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                        flex: 1;
                    }

                    .themes-selector .k-dialog .k-dropdownlist
                    {
                        background-color: transparent;
                    }

                    @media (max-width: 1024px)
                    {
                        .themes-selector
                        {
                            width: calc(100vw - 32px) !important;
                            max-width: calc(100vw - 32px) !important;
                            max-height: calc(100dvh - 32px - env(safe-area-inset-bottom));
                            left: 16px !important;
                            top: 16px !important;
                        }

                        .themes-selector .k-dialog
                        {
                            width: 100% !important;
                            max-width: 100% !important;
                            max-height: calc(100dvh - 32px - env(safe-area-inset-bottom));
                            box-sizing: border-box;
                        }

                        .themes-selector .k-dialog-content
                        {
                            overflow: auto;
                            max-height: calc(100dvh - 144px - env(safe-area-inset-bottom));
                            box-sizing: border-box;
                        }

                        .themes-selector .theming
                        {
                            padding: 16px;
                            padding-bottom: calc(20px + env(safe-area-inset-bottom));
                        }

                        .themes-selector .k-dialog-actions
                        {
                            flex-wrap: wrap;
                            gap: 8px;
                            padding: 12px 16px;
                        }

                        .themes-selector .k-dialog-actions .k-button
                        {
                            flex: 1 1 120px;
                        }
                    }
                `}
      </style>
    </Fragment>
  );
};
